import { render } from "./RobotsView.vue?vue&type=template&id=76931bd0"
import script from "./RobotsView.vue?vue&type=script&lang=js"
export * from "./RobotsView.vue?vue&type=script&lang=js"

import "./RobotsView.vue?vue&type=style&index=0&id=76931bd0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__